module.exports = __webpack_public_path__ + "ed305c65beb6bdaa4275836db66465f6.pdf";